// Health metrics configuration
export const HEALTH_CONSTANTS = {
  DAILY_STEP_GOAL: 10000,
  OPTIMAL_SLEEP_MIN: 7,
  OPTIMAL_SLEEP_MAX: 9,
  ACTIVE_MINUTES_GOAL: 30,
  CACHE_DURATION_MS: 55 * 60 * 1000, // 55 minutes
  AUTO_SYNC_INTERVAL_MS: 5 * 60 * 1000, // 5 minutes
} as const;

// Points and levels
export const POINTS_CONSTANTS = {
  BASE_LEVEL_POINTS: 1000,
  LEVEL_MULTIPLIER_THRESHOLD: {
    BASIC: 1.0,
    BRONZE: 1.3, // Level 6+
    SILVER: 1.5, // Level 10+
    GOLD: 1.8, // Level 15+
    PLATINUM: 2.0, // Level 20+
  },
} as const;

// React Query configuration
export const QUERY_CONFIG = {
  STALE_TIME: {
    SHORT: 30 * 1000, // 30 seconds
    MEDIUM: 2 * 60 * 1000, // 2 minutes
    LONG: 5 * 60 * 1000, // 5 minutes
  },
  GC_TIME: {
    SHORT: 5 * 60 * 1000, // 5 minutes
    MEDIUM: 10 * 60 * 1000, // 10 minutes
  },
} as const;
